import {
  LocalityIcon_default
} from "./chunk-BJCDZVYN.mjs";
export {
  LocalityIcon_default as default
};
